export default "__VITE_ASSET__t_EqB4TP__"